import React from 'react';
import { Box, Text, UnorderedList, ListItem, Link } from '@chakra-ui/react';

export const RiflePistol = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        The Rifle & Pistol Ranges at Golden Gun Club are a Members Only Facility. Please inquire with the Pro Shop or look at <Link href="/membership" color="blue.500">our Membership Page</Link> for more information!
      </Text>

      <Text mb={4} color="black">
        The Rifle & Pistol Ranges are divided into three ranges (West, Central and East), hosting 75 total firing points across the ranges.
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem>The East Range hosts berms with target points from 40 to 200 meters.</ListItem>
        <ListItem>The Central Range hosts target points from 50 to 500 meters.</ListItem>
        <ListItem>The West Range hosts the majority of the pistol-range firing points, with target points ranging from 10 feet to 100 yards.</ListItem>
      </UnorderedList>

      <Text mb={4} color="black">
        Multiple steel targets are placed on the range for general member user - PLEASE BE RESPECTFUL in your use of these targets.
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem>No armor piercing, steel core, or bimetal ammo that may ricochet, fragment or damage the targets.</ListItem>
        <ListItem>Please be aware fire danger and if you see sparks upon impact, cease firing and check your ammunition.</ListItem>
        <ListItem>For member placed steel, all pistol targets must be a minimum of 25y from the line; all rifle targets must be a minimum of 100y from the line. All steel targets should be free-swinging, or angled and spring-loaded. NO HARD SET STEEL TARGETS.</ListItem>
      </UnorderedList>
    </Box>
  );
};